package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class MedicineType(private val literal: String) : IEnumType {
	解表药("解表药"),
	清热药("清热药"),
	泻下药("泻下药"),
	祛风湿药("祛风湿药"),
	化湿药("化湿药"),
	利水渗湿药("利水渗湿药"),
	温里药("温里药"),
	理气药("理气药"),
	消食药("消食药"),
	驱虫药("驱虫药"),
	止血药("止血药"),
	活血化瘀药("活血化瘀药"),
	化痰药("化痰药"),
	止咳平喘药("止咳平喘药"),
	安神药("安神药"),
	平肝潜阳药("平肝潜阳药"),
	息风止痉药("息风止痉药"),
	开窍药("开窍药"),
	补虚药("补虚药"),
	收涩药("收涩药"),
	涌吐药("涌吐药"),
	攻毒杀虫去腐敛疮药("攻毒杀虫去腐敛疮药");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "medicine_type"}
	override fun getLiteral(): String {return literal}
}
